<script setup lang="ts">
// types
import type { SectionBannerCompactProps } from '@ts-sections/section-banner-compact/interfaces'
// hooks
import { useSectionBannerCompact } from '@hooks/sections/section-banner-compact.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockBannerCompact from '@Blocks/BlockBannerCompact.vue'

defineOptions({
  name: 'SectionBannerCompact',
})

const props = defineProps<{
  section: SectionBannerCompactProps
}>()

const {
  refBackgroundColor,
} = useSectionBannerCompact({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-banner-compact"
    :data-component="section.__component"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <BlockBannerCompact
      v-if="section.banner"
      :block="section.banner"
    />
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionBannerCompact.scss" />
